// Same palette as the mobile app
export default {
  primary: "#0083d5",
  primaryPressed: "#006fb5",
  primaryLight: "#e6f3fb",
  text: "#1f2933",
  muted: "#6b7785",
  border: "#dde3e9",
  grid: "#edf0f3",
  field: "#f5f7f9",
  hover: "#f2f4f7",
  error: "#c0362c",
  warning: "#b86a12",
  warningLight: "#fff3e3",
  success: "#2e9e4f",
  successLight: "#e8f6ec",
  neutral: "#5f6b78",
  neutralLight: "#edf0f3"
};
